import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './locals/en/translation.json';
import translationFr from './locals/fr/translation.json';
// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: true,

    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translations: translationEn,
      },

      fr: {
        translations: translationFr,
      },
      'fr-CA': {
        translations: translationFr,
      },
    },
    detection: {
      order: ['sessionStorage'],
      caches: ['sessionStorage'],
    },
    ns: ['translations'],
    defaultNS: 'translations',
  });

export default i18n;
